<!-- <link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Chakra+Petch:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet"> -->

<template>
  <SecretKeyPopup v-if="showSecretKeyPopup" :secret-key-enabled="secretKeyEnabled" :secret-key="secretKey"
    @verified="onSecretKeyVerified" @close="showSecretKeyPopup = false" />
  <ComingSoonPopup v-if="comingSoonEnabled" :launch-date-time="launchDateTime" :secret-bypass-code="secretBypassCode" />
  <!--
  <header>  <w-flex align-left wrap>
      <div class="zlogheader-logo" >
         <div style="display: flex; justify-content: flex-start">
            <img src="/images/logog.png" style="margin-top:7px">
         </div>
      </div>
      <w-flex wrap class="text-left">
  -->
  <!-- <div class="xs1 pa1">
          <div class="primary-dark1--bg py3"><h4>AIMS</h4></div>
        </div> -->
  <!--
        <div class="xs11 pa1">
          <div class="primary-dark1--bg chakra-petch-regular">ARTIFICIAL INSEMINATION<br>MANAGEMENT SYSTEM</div>
        </div>
      </w-flex>
   </w-flex>
   </header>
   -->

  <w-app id="app">
    <w-notification v-if="$page.props.flash.success" success transition="bounce" absolute plain round timeout="4000"
      @close="$page.props.flash.success = ''">
      {{ $page.props.flash.success }}
    </w-notification>

    <w-notification v-if="$page.props.message" error transition="bounce" absolute plain round timeout="2000"
      @close="$page.props.flash.notifyerror = ''">
      {{ $page.props.message }}
    </w-notification>

    <div class="aims-main-login-container">
      <div class="w-flex wrap justify-center items-stretch ">
        <div class="xs12 md4 lg4 x4 text-center flex items-stretch">
          <!-- LOGO DI TENGAH -->
          <div class="mb4">
            <img src="/images/logov2.png" style="margin-top:15px; width: 160px;
                        filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.65));">
          </div>

          <!-- TITLE -->
          <w-card class="zloginbox-title text-center">
            <div class="zloginbox-logo">
              <div class="chakra-petch-semibold">LOG MASUK SISTEM AIMS</div>
            </div>
          </w-card>

          <!-- LOGIN BOX -->
          <w-card class="zloginbox">
            <w-alert class="my0 mb2 text-light" v-if="$page.props.message" error transition="bounce" plain round
              no-border dismiss>
              {{ $page.props.message }}
            </w-alert>

            <w-form  @validate="handleLoginAttempt">
              <z-input outline label="ID Pengguna " placeholder="Sila Masukkan ID Pengguna " name="no_id"
                v-model="form.no_id" :validators="[validators.required]" />
              <div class="spacer"></div>

              <z-input outline label="Katalaluan" class="mt5 zloginbox-label chakra-petch-regular"
                placeholder="Sila Masukkan Kata Laluan" :type="isPassword ? 'password' : 'text'"
                :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                @click:inner-icon-right="isPassword = !isPassword" name="password" v-model="form.password"
                :validators="[validators.required]" />

              <div class="mt5 mb5"></div>

              <w-flex justify-between>
                <div></div>
                <div class="zloginbox-label text-right">
                  <inertia-link :href='$route("lupa-katalaluan")'>
                    <w-icon>fal fa-question-circle</w-icon> Lupa kata laluan?
                  </inertia-link>
                </div>
              </w-flex>

              <w-flex justify-center align-center class="mt5">
                <w-button class="my2 btn-zloginbox grow" type="submit">
                  <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon> LOG MASUK
                </w-button>
              </w-flex>

              <w-flex justify-center align-center class="mt5 zloginbox-label">
                <inertia-link :href='$route("register")'>
                  <w-icon class="mr2" xs>fal fa-user-plus</w-icon> DAFTAR
                </inertia-link>
              </w-flex>
            </w-form>
          </w-card>
          <!-- <div style="height: 100px">&nbsp;</div> -->
        </div>


        <div class="xs12 md8 lg8 x8 " style="position: relative;">
            <div class="training-warning-banner" v-if="secretKeyEnabled == true">
              SKRIN INI UNTUK PENGUJIAN SAHAJA
            </div>

            <vueper-slides 
              v-if="slides.length"
              fade
              :touchable="false"
              fixed-height="400px"
              :autoplay="5000"
              pause-on-hover="false"
            >
              <vueper-slide
                v-for="(slide, i) in slides"
                :key="i"
                :image="slide.url"
              >
                <template #content>
                  <div class="slide-content">
                    <h2 class="slide-title">{{ slide.title }}</h2>
                    <div class="slide-description" v-html="slide.content"></div>
                  </div>
                </template>
              </vueper-slide>
            </vueper-slides>

          </div>
      </div>
    </div>

    <div class="aims-main-icon-container">
      <w-flex wrap class="text-center">
        <!-- @click hanya ada di sini pada div utama -->
        <div class="xs6 md3 lg3 xl3 pa1" @click="aiman()">
          <w-flex wrap>
            <div class="xs8">
              <div class="main-icon-text">
                <!-- Tiada @click di sini lagi -->
                <a class="button1 chakra-petch-semibold">BAHAN <br> TERBITAN & eBORANG</a>
              </div>
            </div>
            <div class="xs4">
              <img src="/images/bahan-terbitan.png" width="65" height="65">
            </div>
          </w-flex>
        </div>

        <!-- Ulangi untuk yang lain -->
        <div class="xs6 md3 lg3 xl3 pa1" @click="senarai()">
          <w-flex wrap>
            <div class="xs8">
              <div class="main-icon-text">
                <a class="button1 chakra-petch-semibold">HUBUNGI <br> KAMI</a>
              </div>
            </div>
            <div class="xs4">
              <img src="/images/hubungi-kami.png" width="65" height="65">
            </div>
          </w-flex>
        </div>

        <div class="xs6 md3 lg3 xl3 pa1" @click="sire()">
          <w-flex wrap>
            <div class="xs8">
              <div class="main-icon-text">
                <a class="button1 chakra-petch-semibold">SIRE <br> KATALOG IBVK</a>
              </div>
            </div>
            <div class="xs4">
              <img src="/images/sire.png" width="65" height="65">
            </div>
          </w-flex>
        </div>

        <div class="xs6 md3 lg3 xl3 pa1" @click="manual()">
          <w-flex wrap>
            <div class="xs8">
              <div class="main-icon-text">
                <a class="button1 chakra-petch-semibold">MANUAL <br> PENGGUNA</a>
              </div>
            </div>
            <div class="xs4">
              <img src="/images/manual.png" width="65" height="65">
            </div>
          </w-flex>
        </div>
      </w-flex>
    </div>


    <footer>
      <div class="aims-footer">
        <w-flex align-left wrap>

          <div class="xs12 md2 lg2 xl2">

            <w-flex align-center wrap>
              <div class="zlogfooter-logo"><img src="/images/aims-logo-footer.png"
                  style="height: 80px; width: 180px; margin: -5px auto 0px auto;"></div>
            </w-flex>

          </div>
          <div class="xs12 md10 lg10 xl10">
            <w-flex align-left wrap>
              <div class="aims-footer-right chakra-petch-regular">
                Penafian : Pihak Jabatan Perkhidmatan Veterinar tidak bertanggung jawab terhadap sebarang kehilangan
                atau kerosakan yang di alami karena menggunakan maklumat dalam laman ini.
                Sesuai di papar menggunakan Chrome, Mozila firefox versi baru dengan resolusi 1200 x 1200 <br>
                @ Hakcipta terpelihara 2024, Jabatan Perkhidmatan Veterinar
              </div>
            </w-flex>
          </div>

        </w-flex>
      </div>
    </footer>
    <w-dialog v-model="dialog3.show" :fullscreen="dialog3.fullscreen" width="1200" :persistent="dialog3.persistent"
      :persistent-no-animation="dialog3.persistentNoAnimation" class="modern-dialog" title-class="dialog-header">

      <template #title>
        <div class="dialog-header1">
          <div class="header-left">
            <img src="/images/manual.png" width="45" height="45">
            <span class="header-title">MANUAL PENGGUNA</span>
          </div>
          <w-button class="close-btn" bg-color="red" @click="dialog3.show = false">
            <span>TUTUP</span>
          </w-button>
        </div>
      </template>

      <div class="dialog-content">
        <div class="section">
          <h3 class="section-title">
            MANUAL PENGGUNA
          </h3>
          <div class="modern-table-container">
            <table class="modern-table">
              <thead>
                <tr>
                  <th class="text-center">Bil.</th>
                  <th class="text-left">Nama</th>
                  <th class="text-left">Keterangan</th>
                  <th class="text-left">Pautan</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dt, index) in manual_datas.data" :key="dt.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>
                    <a v-if="dt.url" href="#" @click.prevent="downloadFile(dt.url, dt.url_name)" class="link">
                      {{ dt.tajuk }}
                    </a>
                    <span v-else>{{ dt.tajuk }}</span>
                  </td>
                  <td>{{ dt.keterangan }}</td>
                  <td>
                    <a v-if="dt.pautan" :href="dt.pautan" target="_blank" class="link">
                      <!-- {{ dt.pautan }} -->
                      <w-button>
                        Klik Disini
                      </w-button>
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>


      <template #actions>
        <template v-for="data in manual_datas.links" v-bind:key="data">
          <w-button bg-color="grey-light5--bg" @click="pageManual(data.label)" v-if="data.url">
            <template v-if="manual_datas.current_page == data.label">
              <b style="color: black">{{ data.label }}</b>
            </template>
            <template v-else>
              {{ data.label }}
            </template>
          </w-button>
          <w-button bg-color="grey-light5--bg" v-else>{{ data.label }}</w-button>
        </template>
        <!-- <div class="spacer" />
             <w-button bg-color="grey-light5--bg" @click="dialogadmin.show = false">TUTUP</w-button> -->
      </template>
    </w-dialog>


    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" width="1200" :persistent="dialog.persistent"
      :persistent-no-animation="dialog.persistentNoAnimation" class="modern-dialog" title-class="dialog-header">

      <template #title>
        <div class="dialog-header1">
          <div class="header-left">
            <img src="/images/bahan-terbitan.png" width="45" height="45">
            <span class="header-title">BAHAN TERBITAN & eBORANG</span>
          </div>
          <w-button class="close-btn" bg-color="red" @click="dialog.show = false">
            <span>TUTUP</span>
          </w-button>
        </div>
      </template>

      <div class="dialog-content">
        <div class="section">
          <h3 class="section-title">
            BAHAN TERBITAN
          </h3>
          <div class="modern-table-container">
            <table class="modern-table">
              <thead>
                <tr>
                  <th class="text-center">Bil.</th>
                  <th class="text-left">Tajuk</th>
                  <th class="text-left">Keterangan</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dt, index) in (bh_datas.data || []).filter(dt => dt.jenis === 1)" :key="index">
                  <!-- <tr v-for="(dt, index) in bh_datas.data.filter(dt => dt.jenis === 1)" :key="index"> -->
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>
                    <a :href="dt.pautan" target="_blank" class="link">
                      {{ dt.tajuk }}
                    </a>
                  </td>
                  <td>{{ dt.keterangan }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="section">
          <h3 class="section-title">
            eBORANG
          </h3>
          <div class="modern-table-container">
            <table class="modern-table">
              <thead>
                <tr>
                  <th class="text-center">Bil.</th>
                  <th class="text-left">Tajuk</th>
                  <th class="text-left">Keterangan</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(dt, index) in (bh_datas.data || []).filter(dt => dt.jenis === 2)" :key="index">
                  <!-- <tr v-for="(dt, index) in bh_datas.data.filter(dt => dt.jenis === 2)" :key="index"> -->
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>
                    <a :href="dt.pautan" target="_blank" class="link">
                      {{ dt.tajuk }}
                    </a>
                  </td>
                  <td>{{ dt.keterangan }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <template #actions>
        <template v-for="data in bh_datas.links" v-bind:key="data">
          <w-button bg-color="grey-light5--bg" @click="pageBh(data.label)" v-if="data.url">
            <template v-if="bh_datas.current_page == data.label">
              <b style="color: black">{{ data.label }}</b>
            </template>
            <template v-else>
              {{ data.label }}
            </template>
          </w-button>
          <w-button bg-color="grey-light5--bg" v-else>{{ data.label }}</w-button>
        </template>
        <!-- <div class="spacer" />
             <w-button bg-color="grey-light5--bg" @click="dialogadmin.show = false">TUTUP</w-button> -->
      </template>
    </w-dialog>

    <w-dialog v-model="dialog1.show" :fullscreen="dialog1.fullscreen" width="1200" :persistent="dialog1.persistent"
      :persistent-no-animation="dialog1.persistentNoAnimation" class="modern-dialog" title-class="dialog-header">

      <template #title>
        <div class="dialog-header1">
          <div class="header-left">
            <img src="/images/sire.png" width="48" height="48" class="logo">
            <span class="header-title">SIRE KATALOG</span>
          </div>
          <w-button class="close-btn" bg-color="red" @click="dialog1.show = false">
            <span>TUTUP</span>
          </w-button>
        </div>
      </template>

      <div class="search-container">
        <div class="filter-row">
          <w-select class="filter-select" :items="lkp_ternakan" label="Jenis Ternakan" v-model="carian.lkp_ternakan_id"
            @input="getJurusan(carian.lkp_ternakan_id)" outlined />
          <w-select class="filter-select" :items="lkp_jurusan" label="Jurusan Ternakan" v-model="carian.lkp_jurusan_id"
            @input="getBaka(carian.lkp_jurusan_id)" outlined />
          <w-select class="filter-select" :items="lkp_baka" label="Baka" v-model="carian.lkp_baka_id" outlined />
          <div class="action-buttons">
            <w-button class="action-btn search" @click="setCarian()">
              <w-icon class="mr2" xs>fal fa-search</w-icon>CARI
            </w-button>
            <w-button class="action-btn reset" @click="resetPencarianKatalog()">
              <w-icon class="mr2" xs>fal fa-refresh</w-icon>RESET
            </w-button>
            <w-button class="action-btn print" @click="setPrintKatalog()">
              <w-icon class="mr2" xs>fal fa-print</w-icon>PRINT
            </w-button>
          </div>
        </div>
      </div>

      <div class="catalog-container">
        <div v-if="datas.data && datas.data.length === 0" class="no-data-message">
          <div class="no-data-icon">
            <w-icon xl>fal fa-search</w-icon>
          </div>
          <h3>Tiada Data Dijumpai</h3>
          <p>Sila cuba dengan kriteria carian yang berbeza</p>
        </div>

        <div class="catalog-grid" v-else>
          <div class="catalog-card" v-for="(dt, index) in datas.data" :key="index">
            <div class="card-header">
              <h3 class="baka-name">{{ dt.baka }}</h3>
            </div>
            <div class="card-image-container" @click="detail(dt)">
              <template v-if="dt.url && dt.url !== ''">
                <w-image class="animal-image" :src="dt.url" :alt="dt.nama" />
              </template>
              <template v-else>
                <div class="no-image">
                  Tiada gambar
                </div>
              </template>
            </div>
            <div class="card-footer">
              <h3 class="animal-name">{{ dt.nama }}</h3>
            </div>
          </div>
        </div>
      </div>

      <template #actions>
        <template v-for="data in datas.links" v-bind:key="data">
          <w-button bg-color="grey-light5--bg" @click="page(data.label)" v-if="data.url">
            <template v-if="datas.current_page == data.label">
              <b style="color: black">{{ data.label }}</b>
            </template>
            <template v-else>
              {{ data.label }}
            </template>
          </w-button>
          <w-button bg-color="grey-light5--bg" v-else>{{ data.label }}</w-button>
        </template>
      </template>
    </w-dialog>



    <w-dialog v-model="dialog2.show" :fullscreen="dialog.fullscreen" width="800" :persistent="dialog.persistent"
  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">

  <template #title>
        <div class="dialog-header1">
          <div class="header-left">
            <span class="header-title">BUTIRAN TERNAKAN</span>
          </div>
          <w-button class="close-btn" bg-color="red" @click="dialog2.show = false">
            <span>TUTUP</span>
          </w-button>
        </div>
      </template>

  <div class="dialog2-detail-content" style="display: flex; flex-direction: column; align-items: center; padding: 20px;">
    <!-- Gambar -->
    <div style="width: 100%; max-width: 600px; margin-bottom: 12px;">
      <vueper-slides :slide-ratio="1 / 2" fixed-height="300px" :dragging-distance="50" :bullets="true">
        <vueper-slide v-for="(slid, a) in slides_info" :key="a" :image="slid.image" :style="{
          'background-size': 'contain',
          'background-repeat': 'no-repeat',
          'background-position': 'center',
          'background-color': '#f5f5f5'
        }" />
      </vueper-slides>
    </div>

    <div class="animal-name-card">
    <div class="animal-name-label">
      Nama Ternakan
    </div>

    <div class="animal-name-value">
      {{ info.nama }}
    </div>
  </div>

    <!-- Info Cards (sama seperti di atas) -->
    <div style="display: flex; justify-content: center; width: 100%;">
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; width: 100%; max-width: 700px;">
        <!-- Semua info card sama seperti di atas -->
        <div class="info-card">
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/cow12.png" width="30" height="30">
            </div>
            <div class="info-label">Baka</div>
            <div class="info-value">{{ info.baka }}</div>
          </div>
          <div class="info-divider"></div>
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/id.png" width="30" height="30">
            </div>
            <div class="info-label">No. ID</div>
            <div class="info-value">{{ info.kode }}</div>
          </div>
        </div>
        
        <div class="info-card">
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/prob.png" width="30" height="30">
            </div>
            <div class="info-label">Bapa</div>
            <div class="info-value">{{ info.id_bapa }}</div>
          </div>
          <div class="info-divider"></div>
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/prob.png" width="30" height="30">
            </div>
            <div class="info-label">Ibu</div>
            <div class="info-value">{{ info.id_ibu }}</div>
          </div>
        </div>
        
        <div class="info-card">
          <div class="info-label" style="color: #64748b;">Ciri - Ciri</div>
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/measure.png" width="30" height="30">
            </div>
            <div style="white-space: pre-line; line-height: 1.5; margin: 0; padding: 0;">
              <div class="info-value">{{ info.ciri_ciri }}</div>
            </div>
          </div>
        </div>

        <div class="info-card">
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/cld.png" width="30" height="30">
            </div>
            <div class="info-label">Tarikh Lahir</div>
            <div class="info-value">{{ $zutil.dateformat(info.tarikh_lahir) }}</div>
            <div class="info-value" style="font-size: 12px; color: #64748b;">{{ $zutil.umurbulan(info.tarikh_lahir) }}</div>
          </div>
          <div class="info-divider"></div>
          <div class="info-item">
            <div class="info-icon">
              <img src="/images/negara1.png" width="30" height="30">
            </div>
            <div class="info-label">Sumber</div>
            <div class="info-value">{{ info.negara }}</div>
          </div>
        </div>
        
        <div class="info-card-wide">
          <div class="info-item-wide">
            <div class="info-icon">
              <img src="/images/main.png" width="30" height="30">
            </div>
            <div class="info-label-wide">Kegunaan Utama</div>
            <div class="info-value-wide">{{ info.kegunaan }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <template #actions>
    
  </template>
</w-dialog>
    <w-dialog v-model="dialogadmin.show" :fullscreen="dialogadmin.fullscreen" width="1200"
      :persistent="dialogadmin.persistent" :persistent-no-animation="dialogadmin.persistentNoAnimation"
      class="modern-dialog" title-class="dialog-header">
      <template #title>
        <div class="dialog-header1">
          <div class="header-left">
            <img src="/images/hubungi-kami.png" width="45" height="45">
            <span class="header-title">HUBUNGI KAMI</span>
          </div>
          <w-button class="close-btn" bg-color="red" @click="dialogadmin.show = false">
            <span>TUTUP</span>
          </w-button>
        </div>
      </template>
      <div class="admin-scrol">
        <div class="dashboard2">
          <div class="cardaiman" v-for="(dt, index) in hubungi.data">
            <div class="card-infoadmin">
              <span>
                <h2> {{ dt.label }}</h2>
              </span>
              <span style="color: red">
                <h1> {{ dt.role }}</h1>
              </span>
            </div>
            <w-flex class="flex justify-end">
              <w-image class="maa sh1 bdrsr d-block" :src="dt.avatar"
                style="width: 57px;height: 57px;margin-top: -97px;margin-right: -5px;">
              </w-image>
            </w-flex>
            <!-- <w-tag class="mr4" bg-color="white" round><h2>{{ dt.label }}</h2></w-tag> -->
            <!-- </div> -->
            <div class="card-info">
              <span>
                <p> {{ dt.no_tel_pejabat }}</p>
              </span>
              <span>
                <p> {{ dt.email }}</p>
              </span>
              <span>
                <p> {{ dt.negeri }}</p>
              </span>
              <span>
                <p> {{ dt.cawangan }}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
      <template #actions>
        <template v-for="data in hubungi.links" v-bind:key="data">
          <w-button bg-color="grey-light5--bg" @click="pageHubungi(data.label)" v-if="data.url">
            <template v-if="hubungi.current_page == data.label">
              <b style="color: black">{{ data.label }}</b>
            </template>
            <template v-else>
              {{ data.label }}
            </template>
          </w-button>
          <w-button bg-color="grey-light5--bg" v-else>{{ data.label }}</w-button>
        </template>
        <!-- <div class="spacer" />
             <w-button bg-color="grey-light5--bg" @click="dialogadmin.show = false">TUTUP</w-button> -->
      </template>
    </w-dialog>
  </w-app>
</template>


<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import 'font-awesome/css/font-awesome.min.css'
import ComingSoonPopup from '@/Components/ComingSoonPopup.vue'
import SecretKeyPopup from '@/Components/SecretKeyPopup.vue'

export default {
  components: { VueperSlides, VueperSlide, ComingSoonPopup, SecretKeyPopup },
  props: {
    comingSoonEnabled: {
      type: Boolean,
      default: false
    },
    launchDateTime: {
      type: String,
      default: null
    },
    secretBypassCode: {  // Add this prop
      type: String,
    },
    secretKeyEnabled: {
      type: Boolean,
      default: false
    },
    secretKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPassword: true,
      isPassword1: true,
      showSecretKeyPopup: false,

      form: {
        no_id: '',
        password: '',


      },
      dialog: {
        valid: false,
        show: false,
        fullscreen: true,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      },

      dialog1: {
        valid: false,
        show: false,
        fullscreen: true,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      },

      dialog2: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        height: 1000,
        // item: {}
      },

      dialog3: {
        valid: false,
        show: false,
        fullscreen: true,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        height: 1000,
        // item: {}
      },

      dialogadmin: {
        valid: false,
        show: false,
        fullscreen: true,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        height: 1000,
        // item: {}
      },

      slides: [
      ],
      slides_info: [],
      breakpoints: {
        600: {
          slideRatio: 2 / 3
        }
      },



      datas: [],
      aiman_datas: [],
      admin_datas: [],
      bh_datas: {
        data: [],
        current_page: 1,
        links: []
      },
      hubungi: {
        data: [],
        current_page: 1,
        links: []
      },
      manual_datas: {
        data: [],
        current_page: 1,
        links: []
      },
      info: {},
      lkp_ternakan: [],
      lkp_jurusan: [],
      lkp_negeri: [],
      lkp_baka: [],
      nama: [],
      carian: {
        lkp_ternakan_id: '',
        lkp_jurusan_id: '',
        lkp_baka_id: '',

      },
      cari: {
        lkp_ternakan_id: '',
        lkp_jurusan_id: '',
        lkp_baka_id: '',
      },
      carian_aiman: {


        lkp_negeri_id: '',
        name: ''
      },
      cari_aiman: {

        lkp_negeri_id: '',
        name: ''
      },
      carian_admin: {

        lkp_negeri_id: '',
        name: ''
      },
      cari_admin: {

        lkp_negeri_id: '',
        name: ''
      },
      validators: {
        required: value => !!value || 'Medan Ini Wajib'
        // Other validators...
      }
    }
  },
  methods: {
    handleLoginAttempt() {
      // Check if secret key is enabled
      if (this.secretKeyEnabled) {
        // Show secret key popup instead of proceeding with login
        this.showSecretKeyPopup = true
        this.pendingLogin = true
      } else {
        // If secret key not enabled, proceed with normal login
        this.attemp()
      }
    },

    onSecretKeyVerified() {
      // Secret key verified, now proceed with actual login
      this.showSecretKeyPopup = false

      if (this.pendingLogin) {
        this.attemp()
        this.pendingLogin = false
      }
    },
    attemp() {
      this.$inertia.post('login', this.form, {
        preserveState: true,
      })
    },

    downloadFile(url, fileName) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    aiman(items) {
      // this.getaimanSenarai(items)
      this.dialog.show = true
      this.getaimanSenarai(1)
    },

    sire(items) {
      // this.getsenaraiKatalog()
      this.dialog1.show = true
      this.getsenaraiKatalog(1)
    },
    senarai(items) {
      // this.getsenaraiKatalog()
      this.dialogadmin.show = true
      this.getHubungi(1)
    },

    manual(items) {
      // this.getsenaraiKatalog()
      this.dialog3.show = true
      this.getManualPengguna(1)
    },
    resetPencarian() {
      this.carian_aiman.lkp_negeri_id = ''
      this.carian_aiman.name = ''
      this.setCarianAiman()
    },

    resetPencarianKatalog() {
      // Reset semua model carian
      this.carian.lkp_ternakan_id = ''
      this.carian.lkp_jurusan_id = ''
      this.carian.lkp_baka_id = ''

      // Reset model filter
      this.cari.lkp_ternakan_id = ''
      this.cari.lkp_jurusan_id = ''
      this.cari.lkp_baka_id = ''

      // Kosongkan dropdown jurusan dan baka
      this.lkp_jurusan = []
      this.lkp_baka = []

      // Panggil method untuk ambil semua data tanpa filter
      this.getsenaraiKatalog(1)

    },

    resetPencarianAdmin() {
      this.carian_admin.lkp_negeri_id = ''
      this.carian_admin.name = ''
      this.setCarianAdmin()
    },

    detail(info) {
      // alert('asd')
      this.dialog2.show = true
      this.info = info
      this.getAttahecment(info.id)
    },

    getAttahecment(id) {
      this.$zcomm.get(this.api_service + 'attahecment/list', { model_id: id, model: '\\App\\Model\\SeKatalog' }).then(res => {
        this.attahecment = res
        this.slides_info = [];
        for (var b in this.attahecment) {
          this.slides_info.push({ title: this.attahecment[b].information, image: this.attahecment[b].url })
        }
      })
    },

    getPengumuman() {
      this.$zcomm.get(this.api_service + 'lookup/pengumuman', {}).then(res => {
        this.slides = res
      })
    },

    getBahanTerbitan(page) {
      this.$zcomm.get(this.api_service + 'lookup/bahan_terbitan?page=' + page, {})
        .then(res => {
          this.bh_datas = res
        })
    },

    getManualPengguna(page) {
      this.$zcomm.get(this.api_service + 'lookup/manual_pengguna?page=' + page, {})
        .then(res => {
          this.manual_datas = res
        })
    },

    getaimanSenarai(page) {
      this.$zcomm.get(this.api_service + 'lookup/aiman_senarai?name=' + this.cari_aiman.name + '&lkp_negeri_id=' + this.cari_aiman.lkp_negeri_id + '&page=' + page, {}).then(res => {
        this.aiman_datas = res
      })
    },

    getHubungi(page) {
      this.$zcomm.get(this.api_service + 'lookup/hubungi_kami?page=' + page, {})
        .then(res => {
          this.hubungi = res
        })
    },

    getadminSenarai(page) {
      this.$zcomm.get(this.api_service + 'lookup/admin_senarai?name=' + this.cari_admin.name + '&lkp_negeri_id=' + this.cari_admin.lkp_negeri_id + '&page=' + page, {}).then(res => {
        this.admin_datas = res
      })
    },

    setCarian() {
      this.cari.lkp_ternakan_id = this.carian.lkp_ternakan_id
      this.cari.lkp_jurusan_id = this.carian.lkp_jurusan_id
      this.cari.lkp_baka_id = this.carian.lkp_baka_id
      this.getsenaraiKatalog(1)
    },

    setPrintKatalog() {
      this.cari.lkp_ternakan_id = this.carian.lkp_ternakan_id
      this.cari.lkp_jurusan_id = this.carian.lkp_jurusan_id
      this.cari.lkp_baka_id = this.carian.lkp_baka_id
      this.getsenaraiKatalogPrint(1)
    },

    setCarianAiman() {
      this.cari_aiman.lkp_negeri_id = this.carian_aiman.lkp_negeri_id
      this.cari_aiman.name = this.carian_aiman.name
      this.getaimanSenarai(1)
    },

    setCarianAdmin() {
      this.cari_admin.lkp_negeri_id = this.carian_admin.lkp_negeri_id
      this.cari_admin.name = this.carian_admin.name
      this.getadminSenarai(1)
    },
    page(page) {
      if (page == 'Seterusnya') {
        page = this.datas.current_page + 1
      }

      if (page == 'Sebelum') {
        page = this.datas.current_page - 1
      }
      this.getsenaraiKatalog(page)
    },
    pageBh(page) {
      if (page == 'Seterusnya') {
        page = this.bh_datas.current_page + 1
      }

      if (page == 'Sebelum') {
        page = this.bh_datas.current_page - 1
      }
      this.getBahanTerbitan(page)
    },
    pageHubungi(page) {
      if (page == 'Seterusnya') {
        page = this.hubungi.current_page + 1
      }

      if (page == 'Sebelum') {
        page = this.hubungi.current_page - 1
      }
      this.getHubungi(page)
    },
    pageManual(page) {
      if (page == 'Seterusnya') {
        page = this.manual_datas.current_page + 1
      }

      if (page == 'Sebelum') {
        page = this.manual_datas.current_page - 1
      }
      this.getManualPengguna(page)
    },
    getsenaraiKatalog(page) {
        const params = {
          page: page || 1
        }


        if (this.cari.lkp_ternakan_id && this.cari.lkp_ternakan_id !== 'all') {
          params.lkp_ternakan_id = this.cari.lkp_ternakan_id
        }


        if (this.cari.lkp_jurusan_id && this.cari.lkp_jurusan_id !== 'all') {
          params.lkp_jurusan_id = this.cari.lkp_jurusan_id
        }


        if (this.cari.lkp_baka_id && this.cari.lkp_baka_id !== 'all') {
          params.lkp_baka_id = this.cari.lkp_baka_id
        }

        this.$zcomm.get(this.api_service + 'lookup/senarai_katalog', params)
          .then(res => {
            this.datas = res
          })
          .catch(() => {
            this.datas = {
              data: [],
              current_page: 1,
              links: []
            }
          })
      },

    getsenaraiKatalogPrint(page) {
        let params = []

        if (this.cari.lkp_ternakan_id && this.cari.lkp_ternakan_id !== 'all') {
          params.push('lkp_ternakan_id=' + this.cari.lkp_ternakan_id)
        }

        if (this.cari.lkp_jurusan_id && this.cari.lkp_jurusan_id !== 'all') {
          params.push('lkp_jurusan_id=' + this.cari.lkp_jurusan_id)
        }

        if (this.cari.lkp_baka_id && this.cari.lkp_baka_id !== 'all') {
          params.push('lkp_baka_id=' + this.cari.lkp_baka_id)
        }

        params.push('cetak=1')

        const url = this.api_service + 'lookup/senarai_katalog?' + params.join('&')

        window.open(url, '_blank')
      },


    getTernakan() {
      this.$zcomm.get(this.api_service + 'lookup/ternakan_katalog', {}).then(res => {
        this.lkp_ternakan = res
      })
    },

    getNegeri() {
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
        this.lkp_negeri = res
      })
    },

    getJurusan(i) {
      this.form.lkp_jurusan_id = ''
      this.$zcomm.get(this.api_service + 'lookup/jurusan/' + i, {}).then(res => {
        this.lkp_jurusan = res
      })
    },

    getBaka(i) {
      this.form.lkp_baka_id = ''
      this.$zcomm.get(this.api_service + 'lookup/baka/' + i, {}).then(res => {
        this.lkp_baka = res
      })
    },
  },
  mounted() {
    this.getPengumuman()
    this.getTernakan()
    this.getNegeri()
    this.getBahanTerbitan()
    this.getManualPengguna()
    this.getHubungi()

  },
}
</script>


<style>
* {
  font-size: inherit !important;
}

#app {
  flex-direction: column;
}

.w-app {
  background: url(/images/aiibg.png);
  background-size: cover !important;
  background-repeat: no-repeat !important;

}


.vueperslide__content-wrapper {
  margin-top: 75px !important;
  font-weight: bold !important;
}

.vueper {
  width: 47%;
}

.vueperslide__title {
  font-size: 18px;
  opacity: 0.7;
  background-color: #555555b8;
}

.vueperslide__content {
  background-color: #555555b8;

}


@media only screen and (max-width: 1000px) {
  .slide-img {
    width: 100% !important;
  }
}


.slide-img {
  width: 100%;
}

.dashboard1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 120px;
  padding: 20px;
  /*background: url(/images/revv.png) no-repeat center center/cover;*/
  height: 100%;
}

.dashboard2 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 70px;
  padding: 20px;
  background-color: #f5f5f5;
}

.dashboard3 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 70px;
  padding: 20px;
  background-color: #f5f5f5;
}

.card11 {
  /*background: linear-gradient(135deg, #0abedf, #478ed1), url(/images/bingkai.png) center / cover no-repeat;*/
  background: url(/images/katalog_label.png) center / cover no-repeat;
  border-radius: 15px;
  /*box-shadow: -10px 16px 14px 4px rgb(0 0 0 / 17%);*/
  padding: 20px;
  width: 300px;
  height: 350px;
  color: #fff;
  margin-top: 20px;
  transition: transform 0.3s, box-shadow 0.3s;


}

.cardadmin {
  /*background: linear-gradient(135deg, #0abedf, #478ed1), url(/images/bingkai.png) center / cover no-repeat;*/
  background: url(/images/asd.png) center / cover no-repeat;
  border-radius: 15px;
  box-shadow: -10px 16px 14px 4px rgb(0 0 0 / 17%);
  padding: 20px;
  width: 400px;
  height: 250px;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;


}

.w-image {
  border-radius: 0% 22%;
}

.cardaiman:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.cardadmin:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.cardaiman {
  /*background: linear-gradient(135deg, #0abedf, #478ed1), url(/images/bingkai.png) center / cover no-repeat;*/
  background: url(/images/admin33.jpg) center / cover no-repeat;
  border-radius: 15px;
  box-shadow: -10px 16px 14px 4px rgb(0 0 0 / 17%);
  padding: 20px;
  width: 400px;
  height: 250px;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;


}


.slide-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch; 
  padding: 30px;
  overflow-y: auto;
}
.slide-content::-webkit-scrollbar {
  width: 6px;
}

.slide-content::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.3);
  border-radius: 4px;
}



.slide-title {
  font-size: 28px;
  font-weight: 700;
  margin-top: -20px;
  margin-bottom: 12px;
  text-transform: uppercase;
}


.slide-description {
  max-width: 800px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-line; /* penting untuk line break */
}




.card12 {
  /*background: linear-gradient(135deg, #0abedf, #478ed1), url(/images/bingkai.png) center / cover no-repeat;*/
  background: linear-gradient(120deg, rgb(6 242 219 / 20%), rgb(10 231 226));
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 10px;
  width: 300px;
  text-align: left;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
  justify-content: center;
  padding: 10px;
}

.card12:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  justify-content: center;
}

.card11:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}



.head h2 {
  margin: 0;
  font-family: "Gill Sans Extrabold", sans-serif;
  font-size: 25px;
  margin-bottom: 5px;
  /*margin-right: 95px;*/
  font-weight: bold;
  letter-spacing: 1px;
  text-align: center;

}


.sx2 {
  margin-left: 50px;
}

.card-info11 h2 {
  margin: 0;
  font-size: 25px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #0b78c9;
  letter-spacing: 1px;
  text-align: center;

}

.animal-name-card {
    width: 100%;
    max-width: 600px;
    margin: 0 auto 24px;
    padding: 16px 24px;

    background: #f3f3f3;
    border: 1px solid #e2e8f0;
    border-radius: 16px;

    box-shadow: 0 8px 20px rgba(15, 23, 42, .08);

    text-align: center;
}

.animal-name-label {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 1.2px;
    margin-bottom: 6px;
}

.animal-name-value {
    font-size: 28px;
    font-weight: 700;
    color: #1e40af;
    line-height: 1.3;
}

.card-infonama h2 {
  margin: 0;
  font-size: 25px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 1px;
  text-align: center;

}

.card-info11 p {
  margin-top: 8px;
  margin-right: 95px;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
}

.no-image {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  font-style: italic;
  border-radius: 8px;
}

/* CSS untuk pesan "Tiada Data Dijumpai" */
.no-data-message {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}

.no-data-icon {
  font-size: 60px;
  color: #ccc;
  margin-bottom: 20px;
}

.no-data-message h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
}

.no-data-message p {
  color: #888;
  font-size: 1rem;
}

/* Untuk admin-scrol juga jika perlu */
.admin-scrol {
  min-height: 300px;
}

.admin-scrol .no-data-message {
  padding: 40px 20px;
}


.card-infoadmin {
  min-height: 80px;
  margin-bottom: 10px;
}

.card-infoadmin h2 {
  margin: 0 0 5px -10px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #2472a5;
  letter-spacing: 1px;
  width: 320px;

}

.card-infoadmin h1 {
  margin: 0 0 0 30px;
  font-size: 12px;
  font-family: "Gill Sans Extrabold", sans-serif;
  padding: 5px;
  font-weight: bold;
  color: #204288;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}

.card-info {
  font-size: 15px;
  font-weight: bold;
  color: white;
  margin: -25px 0 0 22px;
  padding: 5px 0 5px 5px;
  line-height: 1.4;
  align-self: flex-end;
  line-height: 2.4;
}

.card-info13 h2 {
  margin: 0;
  margin-left: 86px;
  margin-top: -5px;
  font-size: 15px;
  font-weight: bold;
  color: #0b78c9;
  letter-spacing: 1px;
}

.card-info13 h1 {
  margin: 0;
  margin-left: 86px;
  margin-top: -5px;
  font-size: 18px;
  font-weight: bold;
  color: #0b78c9;
  letter-spacing: 1px;
}

.card-info13 p {
  margin-top: -40px;
  margin-right: 95px;
  margin-left: 85px;
  font-size: 22px;
  font-weight: bold;
  color: #0b78c9;
}

.card-image1 {
  border-radius: 0% 25%;
}




.pengumuman {
  background: #7154bd00;
  border: 1px solid #7154bd00;
  color: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  opacity: 0.9;
  margin-top: -8px;
}

.w-card.zloginbox-title {
  color: #fff;
  text-align: center;
  background: url(/images/builldingfix.png);
  background: #0a0c1a85;
  background-size: cover !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top: 1px solid #7e90a4b8;
  border-left: 1px solid #7e90a4b8;
  border-right: 1px solid #7e90a4b8;
  height: 40px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  opacity: 0.9;

}

.w-app .primary--bg {
  background-color: #383077;
}



.zloginbox {
  margin-left: 20px;
  margin-right: 20px;
}

.zloginbox-logo img {
  height: 150px;
  margin-top: 25px;
  margin-bottom: 25px;
}

.zlogfooter-logo img {
  height: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;

}

.zlogheader-logo img {
  height: 50px;
  margin-top: 0px;
  margin-left: 30px;
  margin-right: 30px;


}

.zloginbox-title-top {
  font-weight: bold;
  font-size: 20px;
  text-shadow: 1px 1px black;

}

.box {
  color: #fff;
  background-color: #7154bd00;
  border: 1px solid #7154bd00;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  padding: 2px 0;
  text-align: center;
  /*margin-left: px;
  margin-right: px ;*/
  margin-top: 1px;
  width: 10px;
  cursor: pointer;
  /* opacity: 0.7; */

}

.table-profil-scrol {
  height: auto;
  max-height: 600px;
  overflow-y: scroll;
}



header {
  color: #fff;
  background: linear-gradient(112.1deg, rgb(32, 38, 57) 11.4%, rgb(63, 76, 119) 70.2%);
  font-family: Arial, sans-serif;
  padding: 2px;
  background: #00000073 !important;
  position: absolute !important;
}

footer {
  color: #fff;
  font-size: 1.2rem;
  background: linear-gradient(112.1deg, rgb(32, 38, 57) 11.4%, rgb(63, 76, 119) 70.2%);
  font-family: Arial, sans-serif;
  padding: 10px;
  background: transparent;
  /*bottom: 0;
  position: sticky;
  height: auto;*/

}


h4 {
  font-size: 40px;
  text-align: left;

}

.aims-main-login p {
  font-size: 45px !important;
  text-align: left;
  line-height: 45px;
  text-shadow: 2px 2px 4px rgb(0 0 0 / 65%);
}


h5 {
  font-size: 120px;
  text-align: left;

}

.button1 {
  color: #fff;
  text-decoration: underline;
}

.button2 {
  color: #fff;
}

.button3 {
  color: #fff;
}

h5.chakra-petch-semibold {
  font-size: 200px !important;
  text-shadow: 2px 2px 4px rgb(0 0 0 / 65%);
  height: 200px;
}

body {
  font-family: Tahoma, Geneva, sans-serif;
}

h1,
h2,
p {
  margin: 10px;
}

h2 {
  margin-top: 3em;
}

#em1,
#em2 {
  font-size: 0.8em;
}

.aims-main-icon {
  line-height: 6px;
  width: 100%;
}

.aims-footer {
  line-height: 6px;
  max-width: 1200px;
  margin: auto;
}

.aims-footer-right {
  font-size: 11px !important;
  line-height: 15px !important;
}

.aims-main-login {
  max-width: 1200px;
  margin: 120px auto 0px auto;
}

.main-icon-text {
  text-align: right;
  padding-right: 7px;
  font-size: 25px !important;
  line-height: 25px;
  display: block;
  width: 100%;
}



/* Font */

.chakra-petch-light {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.chakra-petch-regular {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.chakra-petch-medium {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.chakra-petch-semibold {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.chakra-petch-bold {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.chakra-petch-light-italic {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.chakra-petch-regular-italic {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.chakra-petch-medium-italic {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 500;
  font-style: italic;
}

.chakra-petch-semibold-italic {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 600;
  font-style: italic;
}

.chakra-petch-bold-italic {
  font-family: "Chakra Petch", sans-serif;
  font-weight: 700;
  font-style: italic;
}


.vueper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.vueper-slide {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

.vueper-slide__content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-card {
  background: #f3f3f3;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: white;
  width: 100%;
  max-width: 400px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #64748b;
}

.info-icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-label {
  min-width: 120px;
  font-size: 14px;
  font-weight: bold;
}

.info-value {
  font-size: 14px;
  flex: 1;
  text-align: left;
  color: #1e40af;
}

.info-divider {
  height: 1px;
  background-color: rgb(101 116 139);
  margin: 5px 0;

}

.info-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  min-width: 120px;
}

.info-header h3 {
  margin: 0;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
}

.info-header img {
  margin: 0 auto;
}

.info-content {
  flex: 1;
  font-weight: bold;
  text-align: center;
}

.info-content p {
  margin: 6px 0;
  font-size: 14px;
  color: #ffffff;
  line-height: 1.4;
}

.info-card-wide {
  background: #f3f3f3;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: white;
  width: 100%;
  grid-column: 1 / -1;
  /* Ini akan membuat card melebar penuh */
  margin-top: 10px;
}

.info-item-wide {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  color: #64748b;
  width: 100%;
}

.info-label-wide {
  min-width: 120px;
  font-size: 14px;
  font-weight: bold;
}

.info-value-wide {
  font-size: 14px;
  flex: 1;
  text-align: left;
  color: #1e40af;
  width: 100%;
}

label.w-input__label.w-input__label--inside.w-form-el-shakable.primary {
  color: #fff !important;
  font-family: "Chakra Petch", sans-serif !important;
  text-transform: uppercase;
  opacity: 1;
  font-size: 15px !important;
}

.w-input__input {
  font-size: 13px !important;
}

.zloginbox-label {
  font-size: 13px !important;
  font-family: "Chakra Petch", sans-serif !important;
}

.zloginbox-label a {
  color: #fff;
  font-family: "Chakra Petch", sans-serif !important;
}

.w-app .primary--bg {
  background-color: #4c45c2;
  border: 1px solid #5e59c5;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-size: 13px !important;
  font-family: "Chakra Petch", sans-serif !important;
}

.w-card__content {
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.aims-main-login-container {
  max-width: 1200px;
  /*margin: 125px auto 25px auto;*/
  margin: 0px auto 25px auto;
  width: 100%;
  /* important to keep responsive */
}

.aims-main-icon-container {
  max-width: 1200px;
  margin: 25px auto;
  width: 100%;
  /* important to keep responsive */
}

.w-card.zloginbox {
  background: #0a0c1a85;
  border: 1px solid #7e90a4b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-top: 0px;

}

.aims-title {
  font-size: 75px !important;
  text-align: left;
  line-height: 120px;
  text-shadow: 2px 2px 4px rgb(0 0 0 / 65%);

}

.aims-title-01 {
  font-size: 28px !important;
  text-align: left;
  line-height: 35px;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgb(0 0 0 / 65%);

}

.vueperslides {
  /*background: url(/images/maha.png);*/
  background-size: cover;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 200px;
}

/* Override spacing utk dialog detail (supaya gambar terus ke atas) */
.dialog2-detail-content .vueperslides {
  margin-top: 0 !important;
}

.dialog2-detail-content .vueper {
  width: 100% !important; /* override .vueper { width: 47%; } */
}

.w-input__input {
  background: #fff !important;
}

.modern-dialog {
  --dialog-border-radius: 12px;
  --dialog-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  background: linear-gradient(135deg, #1976d2, #0d47a1);
  color: white;
  padding: 16px 24px;
  border-radius: 12px 12px 0 0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.logo {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.title-text {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.search-container {
  padding: 16px 24px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 24px;
}

.filter-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filter-select {
  flex: 1;
  min-width: 200px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.action-btn {
  border-radius: 6px;
  padding: 10px 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.action-btn.search {
  background-color: #1976d2;
  color: white;
}

.action-btn.reset {
  background-color: #ffc107;
  color: #212529;
}

.action-btn.print {
  background-color: #4caf50;
  color: white;
}

.catalog-container {
  padding: 0 16px;
}

.catalog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  padding: 8px;
}

.catalog-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.catalog-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  padding: 12px 16px;
  background-color: #135fba;
}

.baka-name {
  color: #ffffff;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 600;
}

.card-image-container {
  padding: 16px;
  cursor: pointer;
  width: 240px;
  height: 240px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 6px;
}

.animal-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}



.card-footer {
  padding: 16px;
  text-align: center;
  border-top: 1px solid #eee;
}

.animal-name {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #333;
}

.pagination-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.page-btn {
  min-width: 40px;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #555;
}

.page-btn.active {
  background-color: #1976d2;
  color: white;
}

.page-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.close-btn {
  background-color: #f44336;
  color: white;
  border-radius: 6px;
  padding: 10px 24px;
  font-weight: 500;
}

.dialog-header1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.close-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.dialog-content {
  padding: 20px;
}

.section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #366696;
  margin: 20px 0 15px 0;
  font-size: 1.1rem;
}

.modern-table-container {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  /*background: white;*/
}

.modern-table thead {
  background: #366696;
  color: white;
}

.modern-table th {
  padding: 15px;
  font-weight: 500;
  text-align: left;
}

.modern-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.modern-table tr:last-child td {
  border-bottom: none;
}

/*.modern-table tr:hover {
  background: #f8f9fa;
}*/

.link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #3498db;
  text-decoration: none;
  transition: color 0.2s;
}

.link:hover {
  color: #2980b9;
  text-decoration: underline;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}


.main-icon-text .button1 {
  color: #f7f7f7;
  text-decoration: underline;
  transition: all 0.3s ease;
  display: inline-block;
}


.main-icon-text .button1:hover {
  color: #dc3545;
  transform: translateY(-3px);
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

.training-warning-banner {
  position: absolute;
  top: 205px;
  left: 0;
  right: 0;
  z-index: 50;
  background: rgba(255, 0, 0, 0.85);
  color: white;
  font-family: 'Chakra Petch', sans-serif;
  font-size: 24px;
  font-weight: 700;
  padding: 8px 20px;
  text-align: center;
  letter-spacing: 2px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
}

@media (max-width: 768px) {
  .training-warning-banner {
    font-size: 14px;
    padding: 6px 15px;
    top: 50px;
  }
}
</style>
